import { useState, useEffect } from 'react';
import {
  Button,
  ComboTextField,
  GlanceLoader,
  Icon,
  Tooltip
} from '../ui-components';
import React from 'react';

function EnterKeyState({onJoin, onCancel=()=>{}, enableCancelWhenEmpty, gicon, showCancel = true, minKeyLength = 4}) {
  const enterKeyText = 'Enter key';
  const [key, setKey] = useState(enterKeyText);
  const [joinDisabled, setJoinDisabled] = useState(true);
  const [cancelDisabled, setCancelDisabled] = useState(!enableCancelWhenEmpty);

useEffect(() => {
    setCancelDisabled(!enableCancelWhenEmpty)
  }, [enableCancelWhenEmpty]); //This can be modified by the settings.

  function isTooShort(str, minLength=minKeyLength) {
    return str === undefined || str === null || str.trim().length < minLength;
  }

  function joinHandler(event) {
    event.preventDefault();
    if (!joinDisabled) {
      (typeof(onJoin) === typeof(Function)) ? onJoin(key) : console.log('Join button clicked.');
    }
  }

  function cancelHandler(event) {
    event.preventDefault();
    (typeof(onCancel) === typeof(Function)) ? onCancel() : console.log('Cancel button clicked.');
  }

  function keyChangeHandler(keyText) {
    setKey(keyText);
    let invalidKey = isTooShort(keyText);
    setJoinDisabled(invalidKey);
    setCancelDisabled(!enableCancelWhenEmpty&&isTooShort(keyText,1));
  }

  let comboTextField = <ComboTextField
  size="large"
  id="TextInput"
  placeholder="Enter key"
  shape="rounded-full"
  class="enterKeyTextField"
  onChange={(e) => keyChangeHandler(e.target.value)}
  // named slots syntax slot[slotName in camelCase]
  slotIconLeft={<Icon name="key" size="5.5" />}
  slotAction={
    <Tooltip text="Send offer" offset={6} size="small">
      <Button
        size="small"
        variant="primary"
        disabled={joinDisabled}
        shape="rounded-full"
        onClick={joinHandler}
      >
        Join
      </Button>
    </Tooltip>
  }
/>

  return (
    <>
      <div className="SizeWrapper">
      <div className="rowAlign">
        { gicon && <GlanceLoader size="12" spinning={false} /> }
        <div className="w-80 mb-25">
        <label htmlFor="TextInput" className="offsetAfterLoader inline-flex items-center gap-1 relative antialiased rtl:text-right typography-body-medium-body20 text-neutral-on-surface-text-default pb-1.5" text="Join with key">Join with key</label>
          <div className='borderContainer'>
          {comboTextField}
          {showCancel && <span className='buttonSep'>&nbsp;</span>}
          {showCancel && (<Button
            size="medium"
            variant="secondary"
            shape="rounded-full"
            className="cancel"
            disabled={cancelDisabled}
            animation={false}
            outline={true}
            onClick={cancelHandler}
          >
            Cancel
          </Button>)} 
        </div>
        </div>
        </div>
      </div>
    </>
  );
}

export default EnterKeyState;
